import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import routerConfig from './index';
import CacheRoute, { CacheSwitch } from 'react-router-cache-route'
class AppRouter extends Component {
  /**
   * 渲染路由组件
   */
  renderNormalRoute = (item, index) => {
    return item.component ? (
      <CacheRoute
        key={index}
        path={item.path}
        component={item.component}
        exact={item.exact}
      />
    ) : null;
  };

  render() {
    return (
      <Router>
      <CacheSwitch>
        {/* 渲染路由表 */}
          {routerConfig.map(this.renderNormalRoute)}
      </CacheSwitch>
      </Router>
    );
  }

}

export default AppRouter;